import type { settings as settingsEn } from '../en/settings';

export const settings: typeof settingsEn = {
  title: 'Configuración',

  baby: {
    title: 'Bebé y familia',
    nickname: 'Apodo del bebé',
    nicknamePlaceholder: 'p. ej. Chiquito',
    birthDate: 'Fecha y hora de nacimiento',
    dueDate: 'Fecha probable de parto',
    birthWeight: 'Peso al nacer',
    feedingGoals: 'Metas de alimentación',
    feedingGoalsPlaceholder: '¿Qué le funciona a su familia? La alimentación combinada también cuenta.',
    waitingForSync:
      'Estos datos llegan automáticamente del otro teléfono después de la primera sincronización.',
  },

  units: {
    lb: 'lb',
    oz: 'oz',
    g: 'g',
  },

  prefs: {
    title: 'Preferencias',
    language: 'Idioma',
    english: 'English',
    spanish: 'Español',
    volumeUnit: 'Cantidades de biberón',
    oz: 'oz',
    ml: 'ml',
    weightUnit: 'Peso',
    lboz: 'lb + oz',
    grams: 'gramos',
    theme: 'Apariencia',
    themeAuto: 'Automático',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    accent: 'Color',
    accentNames: {
      purple: 'Morado',
      blue: 'Azul',
      teal: 'Verde azulado',
      rose: 'Rosa',
      clay: 'Terracota',
    },
  },

  partner: {
    title: 'Conexión con su pareja',
  },

  install: {
    title: 'Agregar a la pantalla de inicio',
    intro: 'Tenga First Weeks a un toque de distancia, incluso a las 3 de la mañana. Una vez instalada, también funciona sin conexión.',
    ios: 'iPhone o iPad (Safari)',
    iosSteps: [
      'Abra esta página en Safari.',
      'Toque el menú de opciones (•••) en la barra de direcciones. En iPhones más antiguos el botón de Compartir está en la barra inferior, así que puede pasar al siguiente paso.',
      'Elija Compartir (el cuadrado con una flecha hacia arriba).',
      'Deslice hacia abajo, toque "Agregar a pantalla de inicio" y luego toque Agregar.',
    ],
    android: 'Android (Chrome)',
    androidSteps: [
      'Abra esta página en Chrome.',
      'Toque el menú de tres puntos en la esquina superior.',
      'Toque "Agregar a la pantalla principal" (o "Instalar app") y confirme.',
    ],
    finePrint:
      'Instalarla así viene directamente de su pediatra, no de la App Store ni de Google Play. No hace falta una cuenta de la tienda, no se descarga nada y ninguna tienda guarda registro de lo que instaló. Su registro vive en su teléfono y sigue siendo suyo, y las actualizaciones llegan solas la próxima vez que la abra.',
  },

  about: {
    title: 'Acerca de',
    call: 'Llamar al consultorio',
    website: 'Visitar nuestro sitio web',
    privacy: 'Aviso de privacidad',
    erase: 'Borrar todos los datos',
    eraseWarning:
      'Esto elimina de forma permanente todo lo guardado en este teléfono: cada toma, pañal, peso y ajuste. Si tiene una conexión con su pareja, el otro teléfono conserva su propia copia. Esto no se puede deshacer.',
    eraseConfirm: 'Sí, borrar todo',
  },
};
